module.exports = __webpack_public_path__ + "img/Grupo 1003@2x.c5cd7cbe.png";